import { IntakeForm, FormSection, FieldGroup, SaveAnswer, EnvironmentType } from '../types';
interface FormRecord {
  [id: string]: FieldGroup;
}
/**
 * Normalize the GraphQL data so that its easier to digest on the FE
 *
 */
export function normalizeIntakeForm(form: IntakeForm): IntakeForm {
  return {
    id: form.id,
    title: form.title,
    formSections: form.formSections.map((section: FormSection) => {
      const normalizedFieldGroups = section.fieldGroups.reduce(
        (map: FormRecord, group: FieldGroup) => {
          const id = group.id;
          map[id] = group;
          return map;
        },
        {}
      );

      return {
        ...section,
        fieldGroupsMap: normalizedFieldGroups
      };
    })
  };
}

interface FormAnswers {
  [id: string]: SaveAnswer;
}

/**
 *
 * Creates a map where the key is the id of the formElement
 */
export function mapIntakeFormAnswers(answers: Array<SaveAnswer>): FormAnswers {
  return answers.reduce((map: FormAnswers, answer: SaveAnswer) => {
    map[answer.formElementId] = answer;
    return map;
  }, {});
}

export function intakeFormId(env: EnvironmentType, gender?: 'male' | 'female' | undefined): number {
  if (env === 'production' || env === 'uat') {
    // On production, the form to load is 10
    return gender == 'male' ? 11 : 10;
  }
  // On staging, we load form id 5
  return gender == 'male' ? 94 : 5;
}
